import { SERVER_API_URL, SERVER_DOMAIN } from "../constants/constants";
import axios from "axios";

const getAllEmployee = async () => {
    const getToken = localStorage.getItem("token");
    const config = {
        headers: { Authorization: `Bearer ${getToken}` },
    };
    const url = `${SERVER_API_URL}/admin/admin_employee/getEmployee`;
    const result = await axios.get(url, config);
    return result.data;
};


const addEmployee = async (Data) => {
    console.log(Data, "Datafrontendapi");
    try {
        const getToken = localStorage.getItem("token");
        const config = {
            headers: { Authorization: `Bearer ${getToken}` },
        };
        const url = `${SERVER_API_URL}/admin/admin_employee/addEmployee`;
        const response = await axios.post(url, Data, config);
        console.log(response, "fromfrontend")
        return response.data;
    } catch (error) {
        throw error;
    }
};
const deleteEmployee = async (id) => {
    const getToken = localStorage.getItem("token");
    const config = {
        headers: { Authorization: `Bearer ${getToken}` },
    };
    const url = `${SERVER_API_URL}/admin/admin_employee/deleteEmployee/${id}`;

    try {
        const result = await axios.delete(url, config);
        return result.data;
    } catch (error) {
        throw error; // Propagate the error for handling in your component
    }
};

const activateEmployee = async (id, updatedData) => {
    const getToken = localStorage.getItem("token");
    const config = {
        headers: { Authorization: `Bearer ${getToken}` },
    };
    const url = `${SERVER_API_URL}/admin/admin_employee/activateEmployee/${id}`;

    try {
        const result = await axios.put(url, updatedData, config);
        return result.data;
    } catch (error) {
        throw error; // Propagate the error for handling in your component
    }
};

const deactivateEmployee = async (id, updatedData) => {
    const getToken = localStorage.getItem("token");
    const config = {
        headers: { Authorization: `Bearer ${getToken}` },
    };
    const url = `${SERVER_API_URL}/admin/admin_employee/deactivateEmployee/${id}`;

    try {
        const result = await axios.put(url, updatedData, config);
        return result.data;
    } catch (error) {
        throw error; // Propagate the error for handling in your component
    }
};

const AddAdminPermissionAndFeature = async (Data) => {
    console.log(Data, "Datafrontendapi");
    try {
        const getToken = localStorage.getItem("token");
        const config = {
            headers: { Authorization: `Bearer ${getToken}` },
        };
        const url = `${SERVER_API_URL}/admin/admin_employee/addadminpermission`;
        const response = await axios.post(url, Data, config);
        console.log(response, "fromfrontend")
        return response.data;
    } catch (error) {
        throw error;
    }
}


const GetAllAdminPermissionsData = async () => {
    try {
        const getToken = localStorage.getItem("token");
        const config = {
            headers: { Authorization: `Bearer ${getToken}` },
        };
        const url = `${SERVER_API_URL}/admin/admin_employee/getAlladminPermissionsdata`;
        const response = await axios.get(url, config);
        return response.data;
    } catch (error) {
        throw error;
    }
}

const GetPermissionById = async (id) => {
    console.log(id, 'GetPermission')
    const getToken = localStorage.getItem("token");
    const config = {
        headers: { Authorization: `Bearer ${getToken}` },
    };
    const url = `${SERVER_API_URL}/admin/admin_employee/getpermissionbyid/${id}`;

    try {
        const result = await axios.get(url, config);
        return result.data;
    } catch (error) {
        throw error; // Propagate the error for handling in your component
    }
}

const UpdateFeatureAndPermission = async (updatedData) => {
    const getToken = localStorage.getItem("token");
    const config = {
        headers: { Authorization: `Bearer ${getToken}` },
    };
    const url = `${SERVER_API_URL}/admin/admin_employee/updatefeatureandpermission`;

    try {
        const result = await axios.put(url, updatedData, config);
        return result.data;
    } catch (error) {
        throw error; // Propagate the error for handling in your component
    }
}


const DeletePermissionById = async (id) => {
    const getToken = localStorage.getItem("token");
    const config = {
        headers: { Authorization: `Bearer ${getToken}` },
    };
    const url = `${SERVER_API_URL}/admin/admin_employee/deletepermission/${id}`;

    try {
        const result = await axios.delete(url, config);
        return result.data;
    } catch (error) {
        throw error; // Propagate the error for handling in your component
    }
}

const deletePermission = async (id) => {
    const getToken = localStorage.getItem("token");
    const config = {
        headers: { Authorization: `Bearer ${getToken}` },
    };
    const url = `${SERVER_API_URL}/deletepermission/${id}`;

    try {
        const result = await axios.delete(url, config);
        return result.data;
    } catch (error) {
        throw error; // Propagate the error for handling in your component
    }
}


//  ******** Admin profile By Id **********

const getProfile = async (id) => {
    const getToken = localStorage.getItem("token");
    const config = {
        headers: { Authorization: `Bearer ${getToken}` },
    };
    const url = `${SERVER_API_URL}/admin/admin_employee/getprofilebyid/${id}`;

    try {
        const result = await axios.get(url, config);
        return result.data;
    } catch (error) {
        throw error; // Propagate the error for handling in your component
    }
}

const Sendotp = async (email) => {
    try {
        const getToken = localStorage.getItem("token");
        const config = {
            headers: { Authorization: `Bearer ${getToken}` },
        };
        const url = `${SERVER_API_URL}/admin/admin_employee/sendotp`;
        const response = await axios.post(url, { email }, config);
        return response.data;
    } catch (error) {
        throw error;
    }
}

const GetEmployeeAdminById = async (id) => {
    const getToken = localStorage.getItem("token");
    const config = {
        headers: { Authorization: `Bearer ${getToken}` },
    };
    const url = `${SERVER_API_URL}/admin/admin_employee/getEmployeebyid/${id}`;
    const result = await axios.get(url, config);
    return result.data;
}
const UpdateAdminEmployee = async (payload) => {
    const getToken = localStorage.getItem("token");
    const config = {
        headers: { Authorization: `Bearer ${getToken}` },
    };
    const url = `${SERVER_API_URL}/admin/admin_employee/updateadminEmployee/`;
    const result = await axios.put(url, payload, config);
    return result.data;
}

const updatePermission = async (payload) => {
    const getToken = localStorage.getItem("token");
    const config = {
        headers: { Authorization: `Bearer ${getToken}` },
    };
    const url = `${SERVER_API_URL}/admin/admin_employee/updatefeatureandpermission`;
    const result = await axios.put(url, payload, config);
    return result.data;
}

//  ******** Admin profile By Id **********

export { getAllEmployee, addEmployee, deleteEmployee, activateEmployee, deactivateEmployee, AddAdminPermissionAndFeature, GetAllAdminPermissionsData, GetPermissionById, UpdateFeatureAndPermission, DeletePermissionById, getProfile, Sendotp, GetEmployeeAdminById, UpdateAdminEmployee, deletePermission, updatePermission };
